import styled from 'styled-components';

export const Header = styled.div`
  font-style: italic;
  color: #979797;
`;

export const ToggleText = styled.span`
  display: inline-block;
  margin-left: 10px;
`;
